import { useContext } from 'react';

import { RadioGroupContext } from '../Context';

const useRadioOptionVM = () => {
  const { canUncheck, value: contextValue, setValue: setContextValue } = useContext(RadioGroupContext);

  const handleClick = (currentValue: string | null) => {
    setContextValue((prevVal) => {
      if (prevVal === currentValue && canUncheck) return null;
      return currentValue;
    });
  };

  return {
    contextValue,
    handleClick,
  };
};

export default useRadioOptionVM;
